"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("@0x/utils");
var order_store_1 = require("../order_store");
var utils_2 = require("../utils");
var base_order_provider_1 = require("./base_order_provider");
var CustomOrderProvider = /** @class */ (function (_super) {
    __extends(CustomOrderProvider, _super);
    function CustomOrderProvider(orders, orderStore) {
        var _this = _super.call(this, orderStore) || this;
        void _this.addOrdersAsync(orders);
        return _this;
    }
    // tslint:disable-next-line:prefer-function-over-method
    CustomOrderProvider.prototype.createSubscriptionForAssetPairAsync = function (_makerAssetData, _takerAssetData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    CustomOrderProvider.prototype.getAvailableAssetDatasAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1, _a, assetPairsItems, minAmount, maxAmount, precision, _b, _c, assetPairKey, _d, assetA, assetB, assetDataA, assetDataB;
            return __generator(this, function (_e) {
                assetPairsItems = [];
                minAmount = new utils_1.BigNumber(0);
                maxAmount = new utils_1.BigNumber(2).pow(256).minus(1);
                precision = base_order_provider_1.DEFAULT_TOKEN_PRECISION;
                try {
                    for (_b = __values(this._orderStore.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                        assetPairKey = _c.value;
                        _d = __read(order_store_1.OrderStore.assetPairKeyToAssets(assetPairKey), 2), assetA = _d[0], assetB = _d[1];
                        assetDataA = { assetData: assetA, minAmount: minAmount, maxAmount: maxAmount, precision: precision };
                        assetDataB = { assetData: assetB, minAmount: minAmount, maxAmount: maxAmount, precision: precision };
                        assetPairsItems.push({ assetDataA: assetDataA, assetDataB: assetDataB });
                        assetPairsItems.push({ assetDataA: assetDataB, assetDataB: assetDataA });
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return [2 /*return*/, assetPairsItems];
            });
        });
    };
    // tslint:disable-next-line:prefer-function-over-method
    CustomOrderProvider.prototype.destroyAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    CustomOrderProvider.prototype.addOrdersAsync = function (orders) {
        return __awaiter(this, void 0, void 0, function () {
            var e_2, _a, orders_1, orders_1_1, order, orderSet, _b, _c, _d, _e, e_2_1;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 6, 7, 8]);
                        orders_1 = __values(orders), orders_1_1 = orders_1.next();
                        _f.label = 1;
                    case 1:
                        if (!!orders_1_1.done) return [3 /*break*/, 5];
                        order = orders_1_1.value;
                        orderSet = this._orderStore.getOrderSetForAssets(order.makerAssetData, order.takerAssetData);
                        _c = (_b = orderSet).addAsync;
                        _d = {
                            order: order
                        };
                        _e = {
                            remainingFillableTakerAssetAmount: order.takerAssetAmount
                        };
                        return [4 /*yield*/, utils_2.utils.getOrderHashAsync(order)];
                    case 2: return [4 /*yield*/, _c.apply(_b, [(_d.metaData = (_e.orderHash = _f.sent(),
                                _e),
                                _d)])];
                    case 3:
                        _f.sent();
                        _f.label = 4;
                    case 4:
                        orders_1_1 = orders_1.next();
                        return [3 /*break*/, 1];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_2_1 = _f.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (orders_1_1 && !orders_1_1.done && (_a = orders_1.return)) _a.call(orders_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/, { accepted: orders, rejected: [] }];
                }
            });
        });
    };
    return CustomOrderProvider;
}(base_order_provider_1.BaseOrderProvider));
exports.CustomOrderProvider = CustomOrderProvider;
//# sourceMappingURL=custom_order_provider.js.map